export default __webpack_public_path__ + "assets/check_selected.ab8f17ab.svg";